var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-wrapper grey"},[_c('v-container',{staticClass:"home-deal-types-container"},[_c('h3',[_vm._v("What kind of financing do you need?")]),_c('DealTypeGrid',{on:{"continue":_vm.goToQuestionnaire}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }